import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddWarehousingAbnormalRequest } from 'src/app/core/models/transport-operation/add-warehousing-abnormal-request';
import { CancelWarehousingDetailRequest } from 'src/app/core/models/transport-operation/cancel-warehousing-detail-request';
import { CancelWarehousingRequest } from 'src/app/core/models/transport-operation/cancel-warehousing-request';
import { InboundProgressResp } from 'src/app/core/models/transport-operation/inbound-tracks-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WarehousingSearchService {

  constructor(
    private http: HttpClient
  ) { }


  searchWarehousing(warehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/search/warehousing`;
    return this.http.post(url, warehousingForm);
  }

  searchWarehousingDetail(whNo: string):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/search/warehousingDetail/${whNo}`;
    return this.http.get(url);
  }

  assignWarehousing(warehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/assign/warehousing`;
    return this.http.post(url, warehousingForm);
  }

  copyWarehousing(warehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/copy/warehousing`;
    return this.http.post(url, warehousingForm);
  }

  downloadWarehousing(warehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/download/warehousing`;
    return this.http.post(url, warehousingForm, {responseType: 'blob'});
  }

  getsDownload(warehousingForm: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/getsDownload`;
    return this.http.post(url, warehousingForm, {responseType: 'blob'});
  }


  async searchWarehousingByWhNo(whNo: string){
    const url = `${environment.logisticsApiUrl}/warehousing/search/searchWarehousingByWhNo/${whNo}`;
    return await this.http.get(url).toPromise();
  }


  getWarehousingPDF(whNo: string):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/download/warehousing/${whNo}`;
    return this.http.get(url, {responseType: 'blob'});
  }


  updateWarehousing(warehousingForm: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/update/warehousing`;
    return this.http.put(url, warehousingForm);
  }


  printWarehousingPDF(whNo : string):Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/print/warehousing/${whNo}`;
    return this.http.get(url);
  }

  printBatchWarehousingPDF(whNos: string[]): Observable<any> {
    const url = `${environment.logisticsApiUrl}/warehousing/print/warehousing/batch`;
    return this.http.post(url, whNos);
  }

  cancelWarehousing(deleteObj: CancelWarehousingRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/cancelWarehousing`;
    return this.http.post(url, deleteObj);
  }

  cancelWarehousingDetail(deleteObj: CancelWarehousingDetailRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/cancelWarehousingDetail`;
    return this.http.post(url, deleteObj);
  }

  cancelWarehousingDetailForTaxPay(deleteObj: CancelWarehousingDetailRequest[]): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/cancelWarehousingDetailForTaxPay`;
    return this.http.post(url, deleteObj);
  }

  updateBondedNo(file: any,  updateUser : string): Observable<any>{
    let url = `${environment.logisticsApiUrl}/warehousing/update/bondedNo`;
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('updateUser', updateUser);
    let response = this.http.put(url, formData ,  {
      reportProgress: true,
      responseType: 'json'
    } );
    return response;
  }

  /**
   * import Warehousing RMB Price by excel
   * @param file upload file
   */
  importWarehousingRMBPriceByExcel(file: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/file/warehousingRMBPrice`;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    let response = this.http.post(url, formData);
    return response;
  }

  /**
   * add Warehousing RMB Price
   */
  addWarehousingRMBPrice(saveObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/add/warehousingRMBPrice`;
    return this.http.post(url, saveObj);
  }

  /**
   * get Warehousing RMB Price
   */
  getWarehousingRMBPrice(whNo: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/get/warehousingRMBPrice`;
    return this.http.post(url, whNo);
  }

  /**
   * import WareHousing Detail
   *
   * @param {*} importObj
   * @return {*}  {Observable<any>}
   * @memberof WarehousingSearchService
   */
  importDetail(importObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/import/warehousingDetail`;
    return this.http.post(url, importObj);
  }

  /**
   * import dropship to warehousing detail
   *
   * @param {*} importObj
   * @return {*}  {Observable<any>}
   * @memberof WarehousingSearchService
   */
  importDropShip(importObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/dropshipmentImport`;
    return this.http.post(url, importObj);
  }

  /**
   * create Booking by warehousing
   *
   * @param {*} createObj
   * @return {*}  {Observable<any>}
   * @memberof WarehousingSearchService
   */
  createBooking(createObj: any, facility: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/booking?specificFacility=${facility}`;
    return this.http.post(url, createObj);
  }

  referenceKeyForDetail(whNo : string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/referenceKey/${whNo}`;
    return this.http.get(url);
  }

  updateWarehousingRelatedBilling(requestParam: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/warehousing/updateWarehousingRelatedBilling`;
    return this.http.post(url, requestParam);
  }

  queryWhEventStatusByAd(params:any) : Observable<InboundProgressResp> {
    const url = `${environment.logisticsApiUrl}/warehousing/getWhEventStatusByAD`;
    return this.http.post<InboundProgressResp>(url,params);
  }

  queryWhEventStatusByWh(params:any) : Observable<InboundProgressResp> {
    const url = `${environment.logisticsApiUrl}/warehousing/getWhEventStatusByWh`;
    return this.http.post<InboundProgressResp>(url,params);
  }

  addWarehousingAbnormalRecord(request: AddWarehousingAbnormalRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/addWarehousingAbnormalRecord`;
    return this.http.post(url, request);
  }

  addWarehousingAbnormalRecordWithValidation(request: AddWarehousingAbnormalRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/addWarehousingAbnormalRecordWithValidation`;
    return this.http.post(url, request);
  }

  verifyHawbNoWithBillOfLading(request: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/verifyHawbNoWithBillOfLading`;
    return this.http.post(url, request);
  }

  verifyHawbNoWithBillOfLadingByWhNo(request: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/warehousing/verifyHawbNoWithBillOfLadingByWhNo`;
    return this.http.post(url, request);
  }

}
